import React, {
  useEffect, useState,
} from 'react';
import classNames from 'classnames';

// import SiteSeeContext from '../SiteSeeGuides/SiteSeeContext';
import { useWindowStore } from '../../stores';
import useSiteSeeModalDims from '../SiteSeeGuides/useSiteSeeModalDims';

import { ReactComponent as ArrowDown } from '../../SVGAssets/arrow-down.svg';

import './OnImageDropdown.scss';

const OnImageDropdown = (props) => {
  const {
    dropdownId,
    className,
    title,
    optionsLocation,
    closeDropdownOnClick,
    options,
    handleOptionOnClick,
    externalActiveOptionId,
    useExternalToggle,
    externalToggleActive,
    setExternalToggleActive,
    anchorDropdownToArrow,
    altToggleSvg,
    children,
  } = props;

  const [defaultOption, setDefaultOption] = useState(null);
  const [activeOption, setActiveOption] = useState(null);
  const [toggleActive, setToggleActive] = useState(false);

  const isMobile = useWindowStore((state) => state.isMobile);

  const onMobileCloseBarClick = () => {
    setToggleActive(false);
    setExternalToggleActive(false);
  };

  const onOptionClick = (option) => {
    setActiveOption(option);
    handleOptionOnClick(option);
    if (closeDropdownOnClick) {
      setToggleActive(false);
    }
  };

  useEffect(() => {
    if (useExternalToggle && (toggleActive !== externalToggleActive)) {
      setToggleActive(externalToggleActive);
    }
  }, [useExternalToggle, externalToggleActive, toggleActive]);

  // set default option
  useEffect(() => {
    if (options) {
      let rawDefaultOption = null;
      // check each option for a default property
      options.forEach((option) => {
        if (option.isDefault) {
          rawDefaultOption = option;
        }
      });
      // if none of options have a default property,
      // set the first one to default
      if (!rawDefaultOption) {
        rawDefaultOption = options[0];
      }
      setDefaultOption(rawDefaultOption);
    }
  }, [options]);

  // set initial active option (only if no external option is set)
  useEffect(() => {
    if (defaultOption && !externalActiveOptionId) {
      setActiveOption(defaultOption);
    }
  }, [defaultOption, externalActiveOptionId]);

  // Set active option if it is externally set.
  useEffect(() => {
    if (externalActiveOptionId && options?.length > 0) {
      const externalActiveOption = options.find((option) => option.id === externalActiveOptionId);
      if (externalActiveOption) {
        setActiveOption(externalActiveOption);
      }
    }
  }, [externalActiveOptionId, options]);

  // Measure the arrow dimensions and update the siteSeeModalDims.
  // Hook returns a callback ref that triggers measurement when element mounts
  const arrowRef = useSiteSeeModalDims({ idAlias: dropdownId });

  return (
    <div className={classNames('onImageDropdown', {
      [`${className}`]: className,
    })}
    >

      {(optionsLocation !== 'left') && (activeOption || children) && !isMobile && (
        <div className="onImageDropdown__activeOption">
          {activeOption?.text || title}
        </div>
      )}

      {((options && defaultOption && activeOption) || children) && (
        <div
          className={
            classNames(
              'onImageDropdown__toggleAndOptions',
              { 'onImageDropdown__toggleAndOptions--active': toggleActive },
              { 'onImageDropdown__toggleAndOptions--anchorDropdownToArrow': anchorDropdownToArrow },
            )
          }
          ref={arrowRef}
        >

          {!useExternalToggle && (
            <button
              className={
                classNames(
                  'onImageDropdown__toggleBtn',
                  { 'onImageDropdown__toggleBtn--active': toggleActive },
                )
              }
              onClick={() => setToggleActive(!toggleActive)}
              type="button"
            >
              {altToggleSvg || <ArrowDown />}
            </button>
          )}

          <div
            className={
              classNames(
                'onImageDropdown__options',
                {
                  'onImageDropdown__options--active': toggleActive,
                  [`onImageDropdown__options--${optionsLocation}`]: optionsLocation,
                  'onImageDropdown__options--hasChildren': children,

                },
              )
            }
          >
            {isMobile && (
              <button
                type="button"
                className="onImageDropdown__option onImageDropdown__option--close"
                onClick={onMobileCloseBarClick}
              >
                <span className="sr-only">Close</span>
                <div className="onImageDropdown__closeBarX" />
              </button>
            )}

            {options?.map((option) => {
              let markup = (<></>);
              if (option.component) {
                markup = (
                  <div>
                    {option.component}
                  </div>
                );
              } else {
                markup = (
                  <button
                    key={option.id}
                    className={
                      classNames('onImageDropdown__option', {
                        'onImageDropdown__option--active': option.id === activeOption.id,
                        [`${option.className}`]: option.className,
                      })
                    }
                    type="button"
                    // Only use autofocus on the map floor nav. If you try to use it in
                    // a modal, the modal will automatically scroll to it.
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus={className === 'mapLevelsNav' && option.isDefault}
                    onClick={() => onOptionClick(option)}
                  >
                    {option.text}
                  </button>
                );
              }
              return markup;
            })}

            {children}
          </div>

        </div>
      )}

      {optionsLocation === 'left' && (activeOption || children) && !isMobile && (
        <div className="onImageDropdown__activeOption">
          {activeOption?.text || title}
        </div>
      )}

    </div>
  );
};

export default OnImageDropdown;
